import React from 'react';

function PledgerIconChecked(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="90"
            height="23"
            viewBox="0 0 90 23"
            fill="none"
            {...props}
        >
            <mask
                id="mask0_3_451"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="90"
                height="23"
            >
                <path d="M89.2633 0H0V23H89.2633V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_3_451)">
                <mask
                    id="mask1_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask1_3_451)">
                    <path
                        d="M14.5631 0.948456C11.5934 0.948456 8.79498 2.66753 7.36722 5.39433C7.36722 5.39433 1.48487 15.8273 1.25643 16.2423C1.02798 16.7758 0.571102 17.1907 0 17.4278C0.0571102 17.6057 0.171332 17.7835 0.228442 17.9613H0.571102C0.970874 17.9613 1.31354 17.7835 1.54198 17.4278L3.54083 14.3454H7.13878C7.99543 14.3454 8.79498 13.8711 9.19475 13.1005L13.7065 5.09794C14.5631 3.61598 15.534 2.25258 16.6762 1.00773H14.5631V0.948456Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask2_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask2_3_451)">
                    <path
                        d="M23.5294 3.55668V10.9072C24.1005 10.9665 24.5574 11.0258 24.9572 11.0258C26.3278 11.0258 27.4129 10.6701 28.1553 9.89947C28.8978 9.18813 29.2404 8.12112 29.2404 6.75771C29.2404 5.27575 28.8978 4.09019 28.2124 3.20101C27.5271 2.31184 26.6134 1.83761 25.5283 1.83761C24.9001 1.83761 24.4432 2.01545 24.1005 2.31184C23.7007 2.60823 23.5294 3.02318 23.5294 3.55668ZM25.1856 17.5464V17.9613H18.7321V17.5464C19.8172 17.25 20.3312 16.4794 20.3312 15.2938V3.85307C20.3312 2.66751 19.8172 1.89689 18.7321 1.65977V1.24483C21.1879 0.948436 23.4723 0.770599 25.5854 0.770599C27.6985 0.770599 29.4118 1.30411 30.7824 2.31184C32.153 3.31957 32.7813 4.62369 32.7813 6.22421C32.7813 7.52833 32.4386 8.65462 31.6962 9.60307C30.9537 10.5515 30.04 11.2629 29.012 11.6778C27.9269 12.0928 26.7847 12.3299 25.5283 12.3299C24.9001 12.3299 24.2718 12.2706 23.5865 12.0928V15.2938C23.5865 15.8273 23.7578 16.3015 24.0434 16.7165C24.2718 17.1314 24.6716 17.4278 25.1856 17.5464Z"
                        fill="white"
                    />
                </g>
                <mask
                    id="mask3_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask3_3_451)">
                    <path
                        d="M36.3221 0V15.5309C36.3221 16.5387 36.7219 17.1907 37.5785 17.5464V17.9613H32.096V17.5464C32.8384 17.1907 33.2382 16.5387 33.2382 15.5309V4.20876C33.2382 3.08248 32.7813 2.37114 31.9246 2.13402V1.71907C33.4666 1.54124 34.8372 0.948454 35.9223 0H36.3221Z"
                        fill="white"
                    />
                </g>
                <mask
                    id="mask4_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask4_3_451)">
                    <path
                        d="M42.0902 7.11341C41.5191 7.11341 41.0051 7.4098 40.6054 7.94331C40.2056 8.47681 39.92 9.30671 39.8629 10.3737H44.1462C44.1462 9.36599 43.9749 8.59537 43.6322 8.00258C43.2324 7.4098 42.7184 7.11341 42.0902 7.11341ZM47.1159 14.6418C46.7733 15.768 46.2022 16.6572 45.2884 17.3093C44.3746 17.9613 43.4038 18.317 42.3187 18.317C40.8909 18.317 39.6345 17.7835 38.6065 16.7758C37.5214 15.768 37.0074 14.3454 37.0074 12.5077C37.0074 10.6701 37.5214 9.18815 38.6065 7.88403C39.6916 6.63918 41.0051 5.98712 42.6613 5.98712C43.9749 5.98712 45.06 6.46135 45.9737 7.29124C46.8304 8.18042 47.2873 9.30671 47.2873 10.7294V11.3222H39.8629C39.92 12.9227 40.2627 14.1083 40.948 14.9382C41.6333 15.768 42.5471 16.183 43.6893 16.183C45.0028 16.183 46.0308 15.5902 46.8304 14.4046L47.1159 14.6418Z"
                        fill="white"
                    />
                </g>
                <mask
                    id="mask5_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask5_3_451)">
                    <path
                        d="M53.6836 16.3608C54.3118 16.3608 54.9972 16.0644 55.6825 15.4717V8.89175C55.6825 8.35825 55.5111 7.9433 55.2256 7.64691C54.94 7.29124 54.4832 7.17268 53.9692 7.17268C53.0554 7.17268 52.313 7.64691 51.7419 8.59536C51.1708 9.54382 50.8852 10.6701 50.8852 12.0335C50.8852 13.3969 51.1137 14.4639 51.6277 15.2345C52.0845 15.9459 52.7699 16.3608 53.6836 16.3608ZM51.9132 18.317C50.771 18.317 49.8001 17.8428 48.9435 16.8351C48.1439 15.8273 47.687 14.5825 47.687 13.1005C47.687 11.2036 48.2581 9.54381 49.4575 8.18041C50.5997 6.81701 52.0845 6.10567 53.8549 6.10567C54.4832 6.10567 55.0543 6.22423 55.6254 6.40206V4.20876C55.6254 3.08248 55.1114 2.43041 54.1405 2.13402V1.71907C55.7396 1.54124 57.1102 0.948454 58.1953 0H58.5951V14.5825C58.5951 15.7088 58.9949 16.4794 59.8515 16.7758V17.1907C58.5951 17.3093 57.3387 17.7242 56.0251 18.4356H55.6254V16.3015H55.5683C55.1114 16.8351 54.5403 17.3093 53.8549 17.6649C53.2838 18.0799 52.5985 18.317 51.9132 18.317Z"
                        fill="white"
                    />
                </g>
                <mask
                    id="mask6_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask6_3_451)">
                    <path
                        d="M64.3061 7.05412C63.1068 7.05412 62.5357 8.00257 62.5357 9.95876C62.5357 10.8479 62.707 11.5593 62.9926 12.0928C63.2781 12.6263 63.735 12.8634 64.3061 12.8634C64.8772 12.8634 65.3912 12.6263 65.6768 12.0928C66.0194 11.5593 66.1907 10.8479 66.1907 9.95876C66.1336 8.00257 65.5054 7.05412 64.3061 7.05412ZM61.3364 20.0361C61.3364 20.6289 61.679 21.0438 62.3644 21.3995C63.0497 21.6959 63.9063 21.8737 65.0485 21.8144C66.0765 21.8144 66.8761 21.6366 67.5043 21.3402C68.1325 21.0438 68.418 20.6881 68.418 20.2139C68.418 20.0361 68.3609 19.8582 68.3038 19.6804C68.2467 19.5026 68.0754 19.384 67.9041 19.2655C67.7327 19.1469 67.5614 19.0283 67.3901 18.9098C67.2187 18.7912 66.9903 18.732 66.6476 18.6134C66.305 18.4948 66.0194 18.4356 65.8481 18.3763C65.6768 18.317 65.3341 18.2577 64.9343 18.1392C64.5345 18.0206 64.1919 17.9613 64.0206 17.9021C62.193 18.2577 61.3364 18.9098 61.3364 20.0361ZM70.8738 19.0283C70.8738 20.2139 70.3027 21.1031 69.1034 21.8144C67.9041 22.5258 66.4192 22.8814 64.6488 22.8814C63.9634 22.8814 63.3352 22.8222 62.707 22.7629C62.0788 22.6443 61.4506 22.5258 60.8795 22.3479C60.3084 22.1701 59.8515 21.8737 59.4517 21.518C59.1091 21.1624 58.9377 20.7474 58.9377 20.2732C58.9377 19.6804 59.3375 19.2062 60.0799 18.732C60.8224 18.2577 61.8504 17.9613 62.9926 17.7835C61.5648 17.3686 60.7082 16.7758 60.3655 15.9459V15.6495C61.6219 15.1753 62.6499 14.5825 63.4495 13.8119C62.3073 13.634 61.3935 13.2191 60.6511 12.5077C59.9086 11.7964 59.566 10.9665 59.566 10.018C59.566 8.95103 60.0228 8.06185 60.9366 7.29123C61.8504 6.52061 62.9926 6.16495 64.3061 6.16495C65.6196 6.16495 66.819 6.57989 67.7898 7.35051C68.5323 6.22422 69.3889 5.63144 70.3598 5.63144C70.7024 5.63144 71.0451 5.75 71.2736 5.98711C71.502 6.22422 71.6733 6.52062 71.6733 6.87629C71.6733 7.23196 71.5591 7.52835 71.3307 7.76546C71.1022 8.00257 70.8167 8.12113 70.5311 8.12113C70.2456 8.12113 69.96 8.00257 69.6174 7.76546C69.3318 7.52835 69.0463 7.40979 68.8749 7.40979C68.6465 7.40979 68.4752 7.52835 68.2467 7.70618C68.8749 8.41752 69.2176 9.18814 69.2176 10.018C69.2176 11.085 68.7607 11.9742 67.7898 12.7448C66.819 13.5155 65.6768 13.8711 64.3632 13.8711H64.249C63.9634 14.1675 63.8492 14.4046 63.8492 14.6417C63.8492 14.8789 64.0777 15.116 64.5917 15.2938C65.1057 15.4716 65.6768 15.6495 66.3621 15.8273C67.0474 16.0051 67.7327 16.183 68.4752 16.4201C69.1605 16.6572 69.7887 17.0129 70.2456 17.4871C70.6453 17.7835 70.8738 18.3763 70.8738 19.0283Z"
                        fill="white"
                    />
                </g>
                <mask
                    id="mask7_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask7_3_451)">
                    <path
                        d="M75.5568 7.11341C74.9857 7.11341 74.4717 7.4098 74.0719 7.94331C73.6722 8.47681 73.3866 9.30671 73.3295 10.3737H77.6128C77.6128 9.36599 77.4414 8.59537 77.0988 8.00258C76.699 7.4098 76.185 7.11341 75.5568 7.11341ZM80.5825 14.6418C80.2398 15.768 79.6687 16.6572 78.755 17.3093C77.8412 17.9613 76.8703 18.317 75.7852 18.317C74.3575 18.317 73.1011 17.7835 72.0731 16.7758C70.988 15.768 70.474 14.3454 70.474 12.5077C70.474 10.6701 70.988 9.18815 72.0731 7.88403C73.1582 6.63918 74.4717 5.98712 76.1279 5.98712C77.4414 5.98712 78.5265 6.46135 79.4403 7.29124C80.297 8.18042 80.7538 9.30671 80.7538 10.7294V11.3222H73.3295C73.3866 12.9227 73.7293 14.1083 74.4146 14.9382C75.0999 15.768 76.0137 16.183 77.1559 16.183C78.4694 16.183 79.4974 15.5902 80.297 14.4046L80.5825 14.6418Z"
                        fill="white"
                    />
                </g>
                <mask
                    id="mask8_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask8_3_451)">
                    <path
                        d="M84.5802 7.17268C84.5802 7.35052 84.5231 7.70619 84.466 8.29897L84.5802 8.35825C84.9229 7.76547 85.3227 7.17268 85.9509 6.69846C86.522 6.22423 87.0931 5.98712 87.6642 5.98712C88.1211 5.98712 88.5209 6.16495 88.8064 6.46134C89.1491 6.81701 89.2633 7.17268 89.2633 7.70619C89.2633 8.18042 89.1491 8.53609 88.8635 8.83248C88.578 9.12887 88.2353 9.3067 87.8926 9.3067C87.55 9.3067 87.1502 9.12887 86.7504 8.7732C86.3507 8.41753 86.008 8.23969 85.7225 8.23969C85.4369 8.23969 85.0371 8.53609 84.5802 9.06959V15.4717C84.5802 16.3608 85.0371 17.0129 85.8938 17.4871V17.9021H80.2399V17.4871C81.0965 17.0722 81.5534 16.3608 81.5534 15.4717V10.018C81.5534 9.42526 81.4392 8.95103 81.2679 8.59536C81.0394 8.29897 80.7539 8.06186 80.2399 7.9433V7.58763C80.9252 7.46907 81.6676 7.29124 82.4101 6.99485C83.1525 6.69846 83.7236 6.28351 84.1805 5.86856H84.5802V7.17268Z"
                        fill="white"
                    />
                </g>
                <mask
                    id="mask9_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask9_3_451)">
                    <path
                        d="M22.1588 20.8067C22.1017 20.7474 22.1017 20.6881 22.0445 20.6289C21.9874 20.5696 21.9303 20.5696 21.8732 20.5103C21.8161 20.5103 21.759 20.451 21.6448 20.451C21.5306 20.451 21.4163 20.451 21.3021 20.5103C21.1879 20.5696 21.1308 20.6289 21.0737 20.7474C21.0166 20.866 20.9595 20.9253 20.9595 21.0438C20.9595 21.1624 20.9023 21.2809 20.9023 21.3995C20.9023 21.518 20.9023 21.6366 20.9595 21.7552C20.9595 21.8737 21.0166 21.9923 21.0737 22.0515C21.1308 22.1701 21.1879 22.2294 21.3021 22.2887C21.4163 22.3479 21.5306 22.3479 21.6448 22.3479C21.8161 22.3479 21.9874 22.2887 22.1017 22.1701C22.2159 22.0515 22.273 21.8737 22.273 21.6959H22.8441C22.8441 21.8737 22.787 22.0515 22.7299 22.1701C22.6728 22.2887 22.5585 22.4072 22.5014 22.5258C22.3872 22.6443 22.273 22.7036 22.1588 22.7629C22.0445 22.8222 21.8732 22.8222 21.7019 22.8222C21.4734 22.8222 21.3021 22.7629 21.1308 22.7036C20.9595 22.6443 20.8452 22.5258 20.731 22.4072C20.6168 22.2887 20.5026 22.1108 20.4455 21.933C20.3884 21.7552 20.3312 21.5773 20.3312 21.3402C20.3312 21.1031 20.3884 20.9253 20.4455 20.7474C20.5026 20.5696 20.6168 20.3917 20.731 20.2732C20.8452 20.1546 20.9595 20.0361 21.1308 19.9768C21.3021 19.9175 21.4734 19.8582 21.7019 19.8582C21.8732 19.8582 21.9874 19.8582 22.1017 19.9175C22.2159 19.9768 22.3301 20.0361 22.4443 20.0954C22.5585 20.1546 22.6156 20.2732 22.7299 20.3918C22.787 20.5103 22.8441 20.6881 22.8441 20.8067H22.273C22.2159 20.9253 22.2159 20.866 22.1588 20.8067Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask10_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask10_3_451)">
                    <path
                        d="M25.1856 20.0954V21.1624H26.2707V20.0954H26.8418V22.8814H26.2707V21.6959H25.1856V22.8814H24.5574V20.0954H25.1856Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask11_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask11_3_451)">
                    <path
                        d="M30.0971 21.8144L29.7544 20.7474L29.3547 21.8144H30.0971ZM30.04 20.0954L31.068 22.9407H30.4398L30.2684 22.2887H29.2404L29.012 22.9407H28.3838L29.4118 20.0954H30.04Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask12_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask12_3_451)">
                    <path
                        d="M33.8664 21.3402C33.9806 21.3402 34.0948 21.2809 34.1519 21.2217C34.2661 21.2217 34.2661 21.1031 34.2661 20.9253C34.2661 20.8067 34.209 20.6882 34.1519 20.6289C34.0948 20.5696 33.9806 20.5103 33.8664 20.5103H33.181V21.2809H33.8664V21.3402ZM34.0948 20.0954C34.209 20.0954 34.3232 20.0954 34.4375 20.1546C34.5517 20.2139 34.6088 20.2732 34.6659 20.3325C34.723 20.3918 34.7801 20.5103 34.8372 20.5696C34.8943 20.6881 34.8943 20.7474 34.8943 20.866C34.8943 21.0438 34.8372 21.1624 34.7801 21.2809C34.723 21.3995 34.6088 21.518 34.4375 21.5773C34.4946 21.5773 34.5517 21.6366 34.6088 21.6959C34.6659 21.7552 34.723 21.8144 34.723 21.8737C34.7801 21.933 34.7801 21.9923 34.7801 22.0516V22.6443C34.7801 22.7036 34.7801 22.7629 34.8372 22.8222C34.8372 22.8814 34.8943 22.9407 34.8943 22.9407H34.2661C34.209 22.8222 34.209 22.7629 34.209 22.6443C34.209 22.5258 34.209 22.4072 34.1519 22.2887C34.1519 22.1108 34.0948 22.0516 34.0377 21.9923C34.0948 21.8144 33.9806 21.8144 33.8092 21.8144H33.181V22.9407H32.6099V20.0954H34.0948Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask13_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask13_3_451)">
                    <path
                        d="M37.4072 20.0954H36.8361V22.9407H37.4072V20.0954Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask14_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask14_3_451)">
                    <path
                        d="M39.0634 20.5696V20.0954H41.2907V20.5696H40.434V22.8814H39.8629V20.5696H39.0634Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask15_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask15_3_451)">
                    <path
                        d="M43.9178 21.8144L43.5751 20.7474L43.2324 21.8144H43.9178ZM43.9178 20.0953L44.9457 22.9407H44.3175L44.0891 22.2886H43.0611L42.8327 22.8814H42.2616L43.2896 20.0361H43.9178V20.0953Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask16_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask16_3_451)">
                    <path
                        d="M47.687 22.4072H47.8584C47.9155 22.4072 47.9726 22.3479 47.9726 22.3479C48.0297 22.3479 48.0297 22.2887 48.0868 22.2294C48.0868 22.1701 48.1439 22.1108 48.1439 22.0516C48.1439 21.933 48.0868 21.8144 48.0297 21.7552C47.9726 21.6959 47.8584 21.6366 47.7442 21.6366H47.1159V22.4072H47.687ZM47.6299 21.2217C47.7442 21.2217 47.8013 21.2217 47.9155 21.1624C47.9726 21.1031 48.0297 21.0438 48.0297 20.9253C48.0297 20.866 48.0297 20.8067 47.9726 20.7474C47.9726 20.6882 47.9155 20.6882 47.8584 20.6289C47.8013 20.6289 47.8013 20.5696 47.7442 20.5696H47.0017V21.2217H47.6299ZM47.7442 20.0954C47.8584 20.0954 47.9726 20.0954 48.0868 20.1546C48.201 20.1546 48.2581 20.2139 48.3724 20.2732C48.4295 20.3325 48.4866 20.3918 48.5437 20.5103C48.6008 20.6289 48.6008 20.6881 48.6008 20.866C48.6008 20.9845 48.5437 21.1031 48.4866 21.2217C48.4295 21.3402 48.3153 21.3995 48.201 21.4588C48.3724 21.518 48.4866 21.5773 48.6008 21.6959C48.6579 21.8144 48.715 21.9923 48.715 22.1701C48.715 22.2887 48.715 22.4072 48.6579 22.5258C48.6008 22.6443 48.5437 22.7036 48.4295 22.7629C48.3153 22.8222 48.2581 22.8814 48.1439 22.8814C48.0297 22.9407 47.9155 22.9407 47.8013 22.9407H46.4877V20.0954H47.7442Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask17_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask17_3_451)">
                    <path
                        d="M51.0565 20.0954V22.4072H52.3701V22.8814H50.4283V20.0954H51.0565Z"
                        fill="#CFA477"
                    />
                </g>
                <mask
                    id="mask18_3_451"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="-1"
                    width="90"
                    height="24"
                >
                    <path
                        d="M89.3775 -0.118561H0V23H89.3775V-0.118561Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask18_3_451)">
                    <path
                        d="M56.0251 20.0954V20.5696H54.5974V21.2217H55.9109V21.6959H54.5974V22.4072H56.0822V22.8814H54.0263V20.0954H56.0251Z"
                        fill="#CFA477"
                    />
                </g>
            </g>
        </svg>
    );
}

export default PledgerIconChecked;
